import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { selectIsAuth } from '../../reducers/userDataReducer'
import { getCookie } from '../../helpers/helpers'

import EmailCheckup from './EmailCheckup'
import Login from './Login'
import AuthLayout from './AuthLayout'

const Auth = ({ auth }) => {
  const [email, setEmail] = useState('')
  const [step, setStep] = useState('email-checkup')
  const navigate = useNavigate()

  useEffect(() => {
    if (auth) {
      if (!getCookie('token')) {
        navigate('/login', { replace: true })
      } else {
        navigate('/dashboard', { replace: true })
      }
    }
  }, [auth])

  const renderStep = () => {
    switch (step) {
      case 'email-checkup':
        return <EmailCheckup setStep={setStep} setEmail={setEmail} />
      case 'login':
        return <Login setStep={setStep} email={email} />
      default:
        return null
    }
  }

  return <AuthLayout>{renderStep()}</AuthLayout>
}

Auth.propTypes = {
  auth: PropTypes.bool,
}

export default connect((state) => ({ auth: selectIsAuth(state) }))(Auth)
